export const isDevelopment = (nodeEnv: string): boolean => nodeEnv === "development";

export const isProductionLike = (nodeEnv: string): boolean => nodeEnv === "production" || nodeEnv === "staging";

export const isProduction = (nodeEnv: string): boolean => nodeEnv === "production";

export const isStaging = (nodeEnv: string): boolean => nodeEnv === "staging";

export const ENVIRONMENTS = {
  DEVELOPMENT: "development",
  STAGING: "staging",
  PRODUCTION: "production",
  TEST: "test",
  CRON_WORKER: "cron-worker",
  BOT_WORKER: "bot-worker",
  PAPER_WORKER: "paper-worker",
  LOCAL: "local",
} as const;
export type ENVIRONMENTS = (typeof ENVIRONMENTS)[keyof typeof ENVIRONMENTS];

export const isPreviewEnvironment = (env: string): boolean => /^preview-pr-\d+$/.test(env);
